import { closex, FancyPrice } from '@sky-tv-group/components';
import React, { useState } from 'react';

interface Props {
  subscribed: boolean;
  price: number;
  hide: () => void;
}

const Banner = ({ subscribed, price, hide }: Props) => {
  let labelInCart = subscribed ? 'Subscribed' : 'Remove';
  //   const handleRemove = useHandleRemove(product, kkService);
  const handleRemove = () => alert('REMOVE');

  const [isDisabled, setIsDisabled] = useState(false);

  const handleToggle = async () => {
    setIsDisabled(true);
    await handleRemove();
    setIsDisabled(false);
  };

  return (
    <div className=" h-20 bg-primary-white shadow-md sticky z-50 top-0">
      <div className="container m-auto flex justify-between items-center h-full px-12 md:px-0">
        <button className="text-heading-mobile-l rounded-full md:w-11 md:h-11 w-8 h-8 text-primary-white  bg-primary-bright-blue" onClick={hide}>
          {closex}
        </button>
        <div className="flex flex-row items-center ">
          <FancyPrice
            price={price}
            numberStyles="sm:sky-h1-black sky-h1 font-skyBold w-full"
            containerClasses="text-primary-mid-night relative "
          />
          <div className="w-8"></div>
        </div>
      </div>
    </div>
  );
};

export default Banner;
